import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';

const StoreHeader = ({ cartCount, onCartOpen }) => {
    return (
        <div className="relative overflow-hidden bg-white dark:bg-store-black border-b border-slate-200 dark:border-lime-500/20 py-16 px-4 transition-colors duration-300">
            {/* Background glow */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-lime-500/20 dark:bg-lime-500/10 blur-[80px] rounded-full" />
                <div className="absolute bottom-0 right-1/4 w-[300px] h-[150px] bg-lime-400/10 dark:bg-lime-400/5 blur-[60px] rounded-full" />
            </div>

            {/* Grid pattern overlay */}
            <div
                className="absolute inset-0 opacity-50 dark:opacity-20"
                style={{
                    backgroundImage: `linear-gradient(rgba(163,230,53,0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(163,230,53,0.3) 1px, transparent 1px)`,
                    backgroundSize: '40px 40px',
                }}
            />

            <div className="relative max-w-7xl mx-auto flex items-center justify-between">
                <div className='h-[40vh] flex items-center'>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >

                        <h1 className="text-4xl sm:text-7xl font-bold text-slate-900 dark:text-white leading-tight">
                            Gadgets & <span className="text-lime-600 dark:text-lime-400">Tech</span>

                            <span className="text-slate-500 dark:text-store-gray-light text-3xl sm:text-4xl font-light ml-2">
                                Intelligents
                            </span>
                        </h1>

                        <p className="text-slate-600 dark:text-store-gray mt-3 text-sm max-w-md">
                            Équipements futuristes pour votre quotidien numérique et votre maison connectée.
                        </p>
                    </motion.div>
                </div>

            </div>
        </div>
    );
};

export default StoreHeader;
